module.exports = __webpack_public_path__ + "static/unresolved-app-ui-ccb15ba83c6642b2aedc0374f2fee8d5.mp4";